// Keyed by platformAgentName: `amigo` on FoodAmigos, `assistant` on a partner's dashboard.
export default {
  name: {
    amigo: 'Amigo',
    assistant: 'Assistant',
  },
  close: {
    amigo: 'Fermer Amigo',
    assistant: "Fermer l'assistant",
  },
  brand: 'Marque',
  // No restaurant selected in the dashboard (D18): the header's line.
  no_restaurant: 'Aucun restaurant sélectionné',
  // The header (D4): Chats opens the restaurant's chats in the panel, New chat starts an empty one.
  chats: 'Discussions',
  new_chat: 'Nouvelle discussion',
  back: 'Retour à la discussion',
  // Other chats with answers the person hasn't read (QA45): the line under the header leads to Chats.
  news_elsewhere_one: 'Nouvelles réponses dans une autre discussion',
  news_elsewhere_other: 'Nouvelles réponses dans {{count}} autres discussions',
};
